<app-cc-form-dialog #ccDialog [transPartKey]="transPartKey" [dialogClass]="'user-form'"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue"
                    (dialogFormVisibleChange)="dialogFormVisible?onShow():{}; dialogFormVisibleChange.emit($event);"
             [globalErrorMessage]="formErrorMessage"
></app-cc-form-dialog>

